<template>
  <div>
    <b-modal
      id="modalInfo"
      v-model="isOpen"
      modal-class="modalInfo"
      :title="$t('label_evaluation_evidencesRequested_uploadFile')"
    >
      <span v-if="showWarning">{{
        $t("label_evaluation_evidences_warning_no_file")
      }}</span>
      <b-form-group
        id="file"
        :label="
          $t('label_evaluation_evidencesRequested_messageFormats_lightBox')
        "
        label-for="file"
      >
        <b-form-file
          v-model="file"
          :disabled="link.length > 0"
          :state="Boolean(file)"
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
        />
      </b-form-group>
      <b-form-group
        id="link"
        :label="$t('label_evaluation_evidencesRequested_messageUrl_lightBox')"
        label-for="link"
      >
        <b-input-group>
          <b-input id="link" v-model="link" :disabled="Boolean(file)" />
        </b-input-group>
      </b-form-group>
      <b-form-group
        id="title"
        :label="
          $t('label_evaluation_evidencesRequested_evidencesDescription_title')
        "
        label-for="title"
      >
        <b-input-group>
          <b-input id="title" v-model="title" />
        </b-input-group>
      </b-form-group>
      <b-form-group
        id="descripcion"
        :label="
          $t(
            'label_evaluation_evidencesRequested_evidencesDescription_description'
          )
        "
        label-for="descripcion"
      >
        <b-input-group>
          <b-textarea id="descripcion" v-model="description" />
        </b-input-group>
      </b-form-group>
      <div slot="modal-footer" class="w-100" style="text-align: right" />
      <div slot="modal-footer" class="w-100" style="text-align: center">
        <b-row class="d-flex justify-content-center">
          <b-col cols="4">
            <b-btn @click="isOpen = false">
              {{
                $t(
                  "label_evaluation_requirementEvaluation_evidenceResubmission_warning_cancel"
                )
              }}
            </b-btn>
          </b-col>
          <b-col cols="4">
            <b-btn variant="primary" @click="loadFile()" :disabled="!description || !title || !(file || link)">
              {{ $t("label_evaluation_evidencesRequested_uploadFile") }}
            </b-btn>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import {axiosCall} from "@/utils/axiosCall";
export default {
  name: "EvaluationOrganizationUploadFile",
  props: ["showModal", "requirement", "evaluationId"],
  data() {
    return {
      showWarning: false,
      description: null,
      link: "",
      file: null,
      title: null,
    };
  },
  computed: {
    isOpen: {
      get() {
        return this.showModal;
      },
      set(newValue) {
        this.file = null;
        this.title = null;
        this.description = null;
        this.link = "";
        this.$emit("update:showModal", newValue);
      },
    },
  },
  methods: {
    checkIfEvidencesAreDefined() {
      if (typeof this.requirement.evidences === "undefined") {
        this.requirement.evidences = {};
      }
      if (typeof this.requirement.evidences.files === "undefined") {
        this.requirement.evidences.files = [];
      }
    },

    createFormData() {
      const data = new FormData();
      data.append("file", this.file, this.file.name);
      data.append("name", this.file.name);
      data.append("title", this.title);
      data.append("description", this.description);
      data.append("evaluationId", this.evaluationId);
      data.append("requirementId", this.requirement.id);

      return data;
    },

    processFile: async function () {
      const data = this.createFormData();
      data.append("evidenceType", "file");
      await axiosCall({method: "POST", url:`/Evidences/uploadEvidence/${this.evaluationId}?showSpinner=true`, data,  headers: {
          "Content-Type": "multipart/form-data",
        }})
        .then(() => {
          this.$emit("newData");
          this.isOpen = false;
        });
    },

    processLink: async function () {
      await axios
        .post(`/Evidences/${this.evaluationId}/${this.requirement.id}`, {
          title: this.title,
          description: this.description,
          name: this.link,
          evidenceType: "url",
        })
        .then((response) => {
          this.$emit("newData", response.data);
          this.isOpen = false;
        });
    },
    loadFile: async function () {
      this.checkIfEvidencesAreDefined();
      if (this.file !== null || this.link) {
        if (this.file !== null) {
          await this.processFile();
        }
        if (this.link) {
          await this.processLink();
        }
      } else {
        this.showWarning = true;
      }
    },
  },
};
</script>

<style lang="sass" scoped>


</style>
